import React from 'react';
import { VariableProductContentProps } from '../types';

const VariableProductContent: React.FC<React.PropsWithChildren<VariableProductContentProps>> = (props) => {
  const numberFormatter = Intl.NumberFormat('da-DK');

  return (
    <>
      <td className="d-table-cell product-variable product-item">
        {props.showButton && (
          <div className="edit-custom-checkbox justify-content-end">
            <label className="align-self-center pt-1">
              <input type="checkbox" disabled readOnly />
              <span className="edit-custom-checkbox-check" aria-hidden="true">
                <i className={(props.selected ? '' : 'hidden') + ' fas fa-check'} />
              </span>
            </label>
          </div>
        )}
      </td>
      <td className="product-variable product-item">
        {props.showImage === true && props.variation.vendor_product_variations_image && props.variation.vendor_product_variations_image.length !== 0 ? (
          <label>
            <img width={50} height={50} src={props.variation.vendor_product_variations_image} alt="produkt billede" loading="lazy" />
          </label>
        ) : null}
      </td>
      <td className="d-none d-sm-table-cell product-variable product-item">
        <div className="multi-line-wrapper">
          {props.showSku && <label>{props.variation.vendor_product_variations_sku}</label>}
          {props.showEan && <small>{props.variation.vendor_product_variations_ean}</small>}
        </div>
      </td>
      <td className="d-none d-sm-table-cell product-variable product-item">
        {props.showAttribute && (
          <label>
            {props.variation.vendor_product_variations_attributes}: {props.variation.vendor_product_variations_attributes_value}
          </label>
        )}
      </td>
      <td></td>
      <td className="d-none d-sm-table-cell product-variable product-item">
        {props.showPrice && <label>{numberFormatter.format(props.variation.vendor_product_variations_price)} DKK</label>}
      </td>
    </>
  );
};

export default VariableProductContent;
